import {CheckoutProps} from "../../types/CheckoutProps";
import {formatDateForAmPmDisplay} from "../../utils/friendlyDate";
import {ConversationMessage} from "../../types/ConversationMessage";
import {OrderProps} from "../../types/OrderProps";
import ClickIcon from "../../assets/icons/ClickIcon";
import {RoundFullCheckIcon} from "../../assets/icons/RoundFullCheckIcon";

const CheckoutPanelStep = ({ step }: { step: any }) => {
    if(step.stepType === 'checkout') {
        const checkout = step as CheckoutProps;
        return <div className="checkout-panel-step">
            <div className="step-time">{formatDateForAmPmDisplay(new Date(checkout.createdAt))}</div>
            <div className="checkout-panel-step-inner checkout">
                {checkout.imageUrl ? <img src={checkout.imageUrl} /> : <div className="conversation-icon">C</div>}
                <div className="step-details">
                    <div className="step-title">Checkout Creation</div>
                    <div className="step-detail">ID: {checkout.id}</div>
                    <div className="step-detail">Items: {checkout.items}</div>
                    <div className="step-detail">Price: ${checkout.priceUsd}</div>
                </div>
            </div>
            <div className="checkout-timeline" />
        </div>
    }

    if(step.stepType === 'conversation') {
        const conversation = step as ConversationMessage;
        return <div className="checkout-panel-step">
            <div className="step-time">{formatDateForAmPmDisplay(new Date(conversation.createdAt))}</div>
            <div className="checkout-panel-step-inner conversation">
                {conversation.imageUrl ? <img src={conversation.imageUrl} /> : null}
                <div className="message-content">{conversation.content}</div>
                <div className="step-detail">ID: {conversation.messageHistoryId}</div>
                <div className="step-detail">Status: {conversation.status?.toLowerCase()}</div>
            </div>
            <div className="checkout-timeline" />
        </div>
    }

    if(step.stepType === 'click') {
        const click = step as any;
        return <div className="checkout-panel-step">
            <div className="step-time">{formatDateForAmPmDisplay(new Date(click.createdAt))}</div>
            <div className="checkout-panel-step-inner click">
                <div className="step-icon click-icon"><ClickIcon width={24} color="#1575fb" /></div>
                <div className="step-details">
                    <div className="step-title">Message Click</div>
                    <div className="step-detail">on message {click.messageId}</div>
                </div>
            </div>
            <div className="checkout-timeline" />
        </div>
    }

    if(step.stepType === 'order') {
        const order = step as OrderProps;
        console.log("order: ", order);
        return <div className="checkout-panel-step">
            <div className="step-time">{formatDateForAmPmDisplay(new Date(order.createdAt))}</div>
            <div className="checkout-panel-step-inner order">
                <div className="step-icon order-icon"><RoundFullCheckIcon width={24} color="#1575fb" /></div>
                <div className="step-details">
                    <div className="step-title">Order Completion <span>(ID: {order.id})</span></div>
                    <div className="step-detail">Price: ${order.priceUsd}</div>
                </div>
            </div>
            <div className="checkout-timeline" />
        </div>
    }

    return null;
}

export default CheckoutPanelStep;